import { component } from 'picoapp';
import { SwiperOptions } from 'swiper';
import customScrollbar from 'utils/custom-scrollbar';

export default component(async (node) => {
  const initSwiper = async () => {
    const Swiper = (await import(
      /* webpackChunkName: "swiper" */
      'modules/swiper'
    )).default;

    const swiperParams:SwiperOptions = {
      init: false,
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        minimumVelocity: 0,
      },
      navigation: {
        nextEl: '.carousel--next',
        prevEl: '.carousel--prev',
      },
    };

    const carousel = new Swiper(node, swiperParams);
    carousel.init();
  };

  const initMobile = () => {
    const scrollElement:HTMLElement = node.querySelector('[hide-scrollbar]');
    const scrollbar:HTMLElement = node.querySelector('.scrollbar__slider--wrapper');
    const scrollIndicator:HTMLElement = node.querySelector('.scrollbar__slider--indicator');
    customScrollbar(scrollElement, scrollbar, scrollIndicator);
  };

  const observer = new IntersectionObserver((entires) => {
    entires.forEach((entry) => {
      if (entry.isIntersecting) {
        if (window.innerWidth > 768) {
          initSwiper();
        } else {
          initMobile();
        }
        observer.disconnect();
      }
    });
  });

  observer.observe(node);
});
